import React from "react";
import { ArrowLeft, Flame, MessageSquareQuote } from "lucide-react";
import { Button } from "@/components/ui/button";
import PlateBadge from "@/components/PlateBadge";

export const workState = (card, running) => {
  if (card.status === "completed") return "done";
  if (card.hold === "parts") return "parts";
  if (card.hold === "pause") return "paused";
  if (running) return "working";
  if (card.status === "in_progress") return "idle";
  return "waiting";
};

const STATE_STYLE = {
  waiting: "bg-blue-500/15 text-blue-600 border-blue-500/40",
  working: "bg-emerald-500 text-white border-emerald-500 animate-pulse",
  idle: "bg-amber-500/20 text-amber-600 border-amber-500/40",
  paused: "bg-slate-500/20 text-slate-600 dark:text-slate-300 border-slate-500/40",
  parts: "bg-orange-500/20 text-orange-600 border-orange-500/40",
  done: "bg-emerald-500/15 text-emerald-600 border-emerald-500/40",
};

export const MechanicHeader = ({ card, state, saving, t, onBack }) => {
  const veh = [card.car_make, card.car_model, card.car_year].filter(Boolean).join(" ");
  return (
    <div className="sticky top-16 z-30 -mx-4 px-4 pt-2 pb-3 bg-background/95 backdrop-blur border-b border-border space-y-3" data-testid="mechanic-header">
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="icon" onClick={onBack} data-testid="mechanic-back"><ArrowLeft className="h-5 w-5" /></Button>
        {card.car_plate && <PlateBadge plate={card.car_plate} country={card.car_country || "NL"} />}
        <div className="min-w-0 flex-1">
          <div className="font-display text-lg sm:text-2xl font-bold truncate leading-tight">{veh || t("vehicle")}</div>
          <div className="text-xs sm:text-sm text-muted-foreground truncate">{card.card_number} · {card.customer_name}{card.car_km ? ` · ${card.car_km} km` : ""}</div>
        </div>
        {card.priority === "high" && <Flame className="h-5 w-5 text-rose-500 shrink-0" />}
        <span className={`shrink-0 px-3 py-1.5 rounded-full border text-xs font-bold uppercase tracking-wider ${STATE_STYLE[state]}`} data-testid="mechanic-state">{t(`mech_state_${state}`)}</span>
      </div>
      <div className="rounded-2xl border-l-4 border-primary bg-primary/10 p-3 sm:p-4" data-testid="mechanic-complaint">
        <div className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-widest text-primary mb-1"><MessageSquareQuote className="h-3.5 w-3.5" />{t("customerComplaint")}</div>
        <p className="text-base sm:text-lg font-medium leading-snug">{card.complaint || <span className="text-muted-foreground italic">{t("mech_no_complaint")}</span>}</p>
      </div>
      <div className="text-[11px] text-muted-foreground text-right h-3" data-testid="mechanic-autosave">{saving ? t("mech_saving") : t("mech_autosaved")}</div>
    </div>
  );
};
